export default "__VITE_ASSET__e1000176__"